module.exports = __webpack_public_path__ + "img/logo.d9690852.svg";